import http from '@/plugins/alldata'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
// import axios from 'axios'
// const apiUrl = window.config ? window.config.alldataHost : ''
const clientid = window.config ? window.config.alldataClientId : ''
const secret = window.config ? window.config.alldataSecret : ''

export default {
  clearToken ({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  async getToken ({ commit }) {
    let t = await http.auth('/ADAG/oauth/token', {
      clientid: clientid,
      secret: secret
    })
    // const data = new URLSearchParams()
    // data.append('grant_type', 'client_credentials')
    // data.append('scope', 'read')
    // let t = await axios({
    //   url: `${alldataHost}/ADAG/oauth/token`,
    //   method: 'POST',
    //   auth: {
    //     username: clientid,
    //     password: secret
    //   },
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   },
    //   data,
    //   withCredentials: true
    // })
    commit(types.SET_TOKEN, t.data)
  },
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setVin ({ commit }, vin) {
    commit(types.SET_VIN, vin)
  },
  setVehicle ({ commit }, vehicle) {
    commit(types.SET_VEHICLE, vehicle)
  },
  async searchVehicle ({ commit, state, dispatch }, vin) {
    const t = await startLoading(dispatch, 'searchVehicle', () =>
      http.get(`ADAG/car-lookup/v3/vins/${vin}`)
    )
    return t.data
  },
  async getVehicleComponents({ commit, dispatch }, carid) {
    const t = await startLoading(dispatch, 'getVehicleComponents', () =>
      http.get(`ADAG/repair/ADConnect/v5/carids/${carid}/components/1`, {}, { headers: {'Accept': 'application/hal+json'} })
    )
    commit(types.SET_COMPONENTS, t.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alldata/actions.js